export default __webpack_public_path__ + "static/media/mentor.757cd949.jpg";